"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateExpiry = void 0;
function validateExpiry(exp, now, policy) {
    // Define acceptable policies
    var supportedPolicies = [
        'when-present', 'force', 'ignore'
    ];
    // Set defaults
    policy = policy || 'when-present';
    now = now || Date.now();
    if (!supportedPolicies.includes(policy))
        throw new Error("Unsupported 'exp' validation strategy '" + policy + "'");
    if (policy !== 'ignore') {
        if (typeof exp !== 'undefined') {
            if (exp * 1000 < now)
                throw new Error("Token is expired");
        }
        else if (policy === 'force') {
            throw new Error("Non-expiring tokens are not acceptable");
        }
    }
}
exports.validateExpiry = validateExpiry;
//# sourceMappingURL=expiry.js.map